'use client'

import { useSession } from 'session/src/hooks/useSession'
import useSWRImmutable from 'swr/immutable'

import { GET_NOTIFICATIONS_URL } from '../constants/notifications'
import { getNotificationsService } from '../services/getNotificationsService'

export const useGetNotifications = () => {
	const { token } = useSession()
	const { accountId } = useSession()

	const { data } = useSWRImmutable(
		token && accountId ? GET_NOTIFICATIONS_URL : null,
		() => getNotificationsService({ token, accountId })
	)

	return { notificationsResponse: data }
}
